(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Poblacions
   *
   * @description
   *
   */
  angular
  .module('neo.services')
  .factory('Poblacions', Poblacions);

  function Poblacions($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/towns');
  }
}());
